



















































































































import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "./Api";
import {DateTime, FamocoDevice, SimRow, Terminal, TerminalConfigNext} from "../../modules/models";
import UserRequired from "../UserRequired";
import SuperSheet from "@/components/shared/SuperSheet.vue";
import rd from "@/modules/vRoutedefs";

const threeMonthsAgo = DateTime.now().monthOffset(-3);

@Component({
    components: {
        "at-super": SuperSheet,
    }
})
export default class SuperTerminal extends UserRequired {
    @Inject()
    api!: Api;

    @Prop()
    terminal!: Terminal;
    @Prop({default: null})
    sim!: SimRow | null;
    @Prop({default: null})
    config!: TerminalConfigNext | null;
    @Prop({default: null})
    famoco!: FamocoDevice | null;

    get terminalGuid() {
        return this.terminal.guid;
    }

    get orgNum() {
        return this.terminal.companyOrgNum;
    }

    showDeleteBtn() {
        return this.terminal.cleanupTs == null && (this.terminal.appVersion > 38 ||
            (this.terminal.lastSyncTs != null && this.terminal.lastSyncTs.isBefore(threeMonthsAgo)));
    }
    showDeleteConfirm = false;

    async deleteTerminal() {
        const resp = await this.api.cleanupDevice(this.terminalGuid);
        this.showDeleteConfirm = false;
        this.snackMsg(resp);
    }

    get terminalHasDeviceid() {
        return this.terminal.phoneDeviceid && this.terminal.phoneDeviceid.length > 2;
    }
    deviceid: string | null = null;
    showReinitDialog = false;
    async reinitDevice() {
        const resp = await this.api.reinitDevice(this.terminalGuid, this.deviceid);
        this.showReinitDialog = false;
        this.snackMsg(resp);
    }

    showSnack = false;
    snackMsgTxt = "";
    snackMsg(msg: string) {
        this.snackMsgTxt = msg;
        this.showSnack = true;
    }

    async fetchDevicelog() {
        await this.api.triggerLogSend(this.terminalGuid);
        this.snackMsg("Loggsending forespurt.");
    }
    async triggerDataUseReport() {
      await this.api.triggerDataUseReport(this.terminalGuid);
      this.snackMsg("Databruk rapport forespurt");
    }

    proresultIntegrationSetting = 0;
    @Watch("terminal", {immediate: true})
    async loadProresultIntegrationSetting() {
        if(this.terminal != null && this.user.isCompanySuper(this.terminal.companyOrgNum)) {
            this.proresultIntegrationSetting = await this.api.getTerminalProresultIntegrationSetting(this.terminal.guid);
        }
    }

    showSetFamocoStatus = false;
    async setFamocoStatus(status: number) {
      if(this.famoco) {
        this.showSetFamocoStatus = false;
        await this.api.setFamocoStatus(this.famoco.id, status);
        this.snackMsg(`Famoco status set`);
        this.$emit("at-refresh-famoco");
      }
    }

    async changeContinuousPushlistner(v: boolean) {
      await this.api.terminalContinuousPushlistenerSet(this.terminal.guid, v);
      this.$emit("at-refresh-terminal");
      this.emitSnack(`Kortleser pushtilkobling innstilling endret. Synkroniser den`);
    }
    get continuousPushlistener() {
      if(this.config) {
        return this.config.continuousPushlistener;
      }
      return this.terminal.continuousPushlistener;
    }
    set continuousPushlistener(v: boolean) {
      if(this.config && v != this.config.continuousPushlistener) {
        this.changeContinuousPushlistner(v);
      } else if(v != this.terminal.continuousPushlistener) {
        this.changeContinuousPushlistner(v);
      }
    }

    // For updating data limits on terminal
    showSetSoftDataLimits = false;
    mobileHourlyMB = 10;
    mobileMonthlyMB = 100;
    async setSoftDataLimits() {
      await this.api.setTerminalSoftDataLimits(this.terminalGuid, this.mobileHourlyMB, this.mobileMonthlyMB);
      this.emitSnack("Databruksgrenser sendt");
      this.showSetSoftDataLimits = false;
    }

    get dataUseReportTo() {
      return {name: rd.super.terminalDataUsage.name, params: {guid: this.terminal.guid}};
    }

}
